// removed by extract-text-webpack-plugin
module.exports = {"Container":"SpinnerImage__Container___2C_h2","Image":"SpinnerImage__Image___2a9Yt","Hidden":"SpinnerImage__Hidden___WQ870","BlurContainer":"SpinnerImage__BlurContainer___16t-j","BluredContainer":"SpinnerImage__BluredContainer___2bGLb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/SpinnerImage/SpinnerImage.scss
// module id = 1474
// module chunks = 0